import * as React from 'react';
import { useIntl } from 'react-intl';
import CallToAction from 'core/components/CallToAction';
import useGoogleAnalytics from 'analytics/hooks/useGoogleAnalytics';
import classnames from 'classnames';
import * as styles from './DigitalWalkInBooking.module.scss';

export type DigitalWalkInBookingProps = {
    setDigitalWalkInModalOpen: (value: boolean) => void;
    eventPrefix: string;
    classes?: Partial<typeof styles>;
};

export default function DigitalWalkInBooking({
    setDigitalWalkInModalOpen,
    eventPrefix,
    classes,
}: DigitalWalkInBookingProps) {
    const intl = useIntl();
    const { trackWithAnyGoogleAnalytics } = useGoogleAnalytics();

    // Use ref to track if the event has been sent
    const hasTrackedRef = React.useRef(false);

    React.useEffect(() => {
        if (!hasTrackedRef.current) {
            trackWithAnyGoogleAnalytics(
                false,
                'event',
                `${eventPrefix}_digitalWalkin`,
                {
                    event_category: 'appointment',
                },
            );

            hasTrackedRef.current = true;
        }
    }, [trackWithAnyGoogleAnalytics, eventPrefix]);

    const onClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        trackWithAnyGoogleAnalytics(
            false,
            'event',
            `${eventPrefix}_digitalWalkinClick`,
            {
                event_category: 'appointment',
            },
        );

        setDigitalWalkInModalOpen?.(true);
    };

    return (
        <div className={classnames(styles.root, classes?.root)}>
            <div className={styles.container}>
                <h5 className={styles.title}>
                    {intl.formatMessage({
                        id: 'booking.form.digitalWalkIn.bookingTitle',
                    })}
                </h5>
                <p className={styles.text}>
                    {intl.formatMessage({
                        id: 'booking.form.digitalWalkIn.bookingText',
                    })}
                </p>
                <CallToAction
                    onClick={onClick}
                    className={styles.cta}
                    size="small"
                >
                    {intl.formatMessage({
                        id: 'booking.form.digitalWalkIn.bookingCta',
                    })}
                </CallToAction>
            </div>
        </div>
    );
}
